import dayjs from "dayjs";

export const validarRangoFechas = (fechaInicio, fechaFin) => {
  const errors = { fechaInicio: "", fechaFin: "" };
  if (fechaInicio && !dayjs(fechaInicio).isValid()) {
    errors.fechaInicio = "La fecha de inicio no es válida";
  }
  if (fechaFin && !dayjs(fechaFin).isValid()) {
    errors.fechaFin = "La fecha de fin no es válida";
  }
  if (
    fechaInicio &&
    fechaFin &&
    !errors.fechaInicio &&
    !errors.fechaFin &&
    dayjs(fechaFin).isBefore(dayjs(fechaInicio), "day")
  ) {
    errors.fechaFin = "La fecha fin debe ser mayor o igual a la fecha inicio";
  }
  return errors;
};
